// This file is required due to Firebase requiring Auto-Login after createConnection. This creates a new firebase instance to create the user

import firebase from 'firebase'
// import 'firebase/firestore'
import firebaseConfig from './firebaseConfig'

export const FbSecondary = firebase.initializeApp(firebaseConfig, 'Secondary')



// WEBPACK FOOTER //
// ./src/firebaseInitCreateUser.js